/*
 * @Description  : 平台增值服务模块 接口管理
 * @Author       : 王帅
 * @Date         : 2026-01-16 11:51:30
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-07-14 17:11:36
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\platform-service\index.js
 */
import request from '../../request.js'

// 查询移动认证服务列表 - 分页 --- 孙强（微服务调用陈启洋接口）
export const selectCompanyFeePage = function(data) {
	return request({
		url: '/ngsBid/selectCompanyFeePage',
		method: 'post',
		data,
		requestConfig: {
			hideLoading: true
		}
	})
}

// 查询认证用户列表 - 分页 --- 孙强（微服务调用陈启洋接口）
export const selectUserFeePage = function(data) {
	return request({
		url: '/ngsBid/selectVerifiedUserFeePage',
		method: 'post',
		data,
		requestConfig: {
			hideLoading: true
		}
	})
}

// 移动CA查看 --- 孙强（微服务调用陈启洋接口）
export const getCaServiceDetail = function(data) {
	return request({
		url: '/ngsBid/getCaServiceDetail',
		method: 'post',
		data
	})
}

// 平台会员服务关闭服务 --- 孙强（微服务调用陈启洋接口）
export const turnOffService = function(data) {
	return request({
		url: '/ngsBid/turnOffService',
		method: 'post',
		data
	})
}

// 移动CA关闭服务 --- 陈启洋（微服务调用）
export const updateMainDetail = function(data) {
	return request({
		url: '/ngsBid/updateMainDetail',
		method: 'post',
		data
	})
}

//平台投标服务费（包年）-分页  --- 朱新宇
export const selectServiceFeePage = function(data) {
	return request({
		url: '/userTenantCenter/selectServiceFeePage',
		method: 'post',
		data,
		requestConfig: {
			hideLoading: true
		}
	})
}

// CA数字证书-CA办理记录分页列表  ------叶凡
export const getPageCas = function(data) {
	return request({
		url: '/ahCa/getPageCas',
		method: 'post',
		data,
		requestConfig: {
			hideLoading: true
		}
	})
}
